module.exports = __webpack_public_path__ + "static/mccarthy-hall-1-9e3c7f713082b541d677af5b55c3b5a9.jpg";